import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import AppContainer from './AppContainer';
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense(`${process.env.REACT_APP_SYNCFUSION_KEY}`);
ReactDOM.render(<AppContainer />, document.getElementById('root') as HTMLElement);
